import React, {useContext} from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {deleteUser, getUsers} from "../api";
import {Store} from "../state_store/provider";
import {USERS} from "../state_store/actionType";
import {Request} from "../utils";

export default function UserDelete(props) {
    const {open, onClose, onOK, data} = props
    const {dispatch} = useContext(Store)
    const onDelete = ()=>{
        const id = data.id
        Request(dispatch, deleteUser(id), onOK).then(error=>{
            if(!error){
                getUsers().then(res => {
                    if (res.result === 0)
                        dispatch({type: USERS, payload: res.userList})
                })
            }
        })
        // deleteUser(id).then(res=>{
        //
        //     if (res.result === 0) {
        //         onOK()
        //         // const users = state.user.filter(res => res.id !== id)
        //         dispatch({type: USERS, payload: res.userList})
        //
        //     }
        // })
    }

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"title"}>ユーザーを削除</div>
                    <div className={"subtitle"}>
                        このユーザーに関連する情報が失われます。
                    </div>
                    <div className={"subtitle"}>
                        削除してよろしいですか？
                    </div>

                </div>
                <div className={"delete-dialog-footer row center"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >キャンセル</Button>
                    <Button
                        onClick={onDelete}
                        type="primary" style={{backgroundColor:"#377EF3"}}>削除する</Button>
                </div>
            </div>
        </Modal>
    );
};
